import { Provider as StepProvider } from '@/contexts/StepContext';
import { Provider as ListingProvider } from '@/contexts/ListingContext';

import FormBox from './containers/FormBox';
import InfoBox from './containers/InfoBox';

export default function ListingWizardApp({userType, userID, ...listing}) {
  return (
    <ListingProvider value={listing}>
      <StepProvider value={listing.step || window.location.hash?.replace('#', '')}>
          <div className="row listing-wizard">
            <FormBox userType={userType} userID={userID}/>
            <InfoBox/>
          </div>
        </StepProvider>
    </ListingProvider>
  );
}

